import { getViemClients, } from "@bracket/contractor-next";
import bytes32 from "bytes32";
import type { Config, } from "@wagmi/core";

import {
	bigintize,
	getContractWithABI,
	getTokenDefinition,
	isBlockHash,
	type BlockHash,
	type ValidChainId,
} from "@bracket/chainography";

import type {
	TokenIdentifier,
} from "@bracket/types";


export declare type ClaimWithdrawalProps = {
	amount: number|bigint;
	token: TokenIdentifier;
	salt?: string;
	salt_bytes?: string;
	timestamp: Date|number;
	chainId?: ValidChainId;
	config?: Config;
};



/**
 * claim a withdrawl
 * @param {TokenIdentifier} token the token to use for colateral
 * @param {bigint|number} amount the amount being withdrawn, in amount of colateral
 * @param {string} salt the salt pairing this withdrawal.
 * @param {string} salt_bytes the salt pairing this withdrawl as a bytestring.
 * @param {Date|number} timestamp either a Date instance set to the right time, or the unix epoch timestamp, in seconds.
 * @param {Config} config the wagmi config, if using it.
 * @param {ValidChainId} chainId , default 1
 * @param param0 
 * @returns 
 */
export const claimWithdrawal = async ({
	token,
	amount,
	salt,
	salt_bytes,
	timestamp,
	config,
	chainId = 1,
}: ClaimWithdrawalProps): Promise<BlockHash> => {

	try {

		if(chainId !== 1)
			throw new Error("claimWithdrawal supports only chain 1");

		if(!salt && !salt_bytes)
			throw new Error("salt neither provided as a key (salt), or bytes (salt_bytes)");

		const [client, wclient] = await getViemClients({ chainId, config, });
		const iToken = getTokenDefinition(token);
		const [address, abi] = getContractWithABI("BrktETH", chainId);
		const biamount = typeof amount === "bigint" ? amount : bigintize(amount, iToken);
		const time = BigInt(typeof timestamp === "number" ? timestamp : timestamp.getTime() / 1000);
		// const time = BigInt(typeof timestamp === "number" ? timestamp : timestamp.getTime());

		salt = salt_bytes || bytes32({ input: salt, });

		const {
			request,
			result,
		} = await client.simulateContract({
			address,
			abi,
			functionName: "claimWithdrawal",
			args: [
				iToken.address,
				biamount,
				time,
				salt
			],
			account: wclient.account.address
		});

		// if(result) {
		const hash = await wclient.writeContract(request);
		if(isBlockHash(hash)) {
			await client.waitForTransactionReceipt({ hash, });
			return hash;
		}
		throw new Error("did not receive a blockhash");
	} catch (err) {

		if(Array.isArray(err.metaMessages) && err.metaMessages.length) {
			if(err.metaMessages.find(m => m.includes("WithdrawalNotReady"))) {
				throw new Error("WithdrawalNotReady");
			}
		}

		throw new Error(`@bracket/chainography/brktETH:burn failed - ${err.message}`);
	}

};
